import React, { useState, useEffect } from 'react';
import { api } from '../../utils/api';

const SubmissionsPanel = () => {
  const [submissions, setSubmissions] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      const data = await api.getSubmissions();
      setSubmissions(data);
    } catch (err) {
      console.error('Failed to load submissions:', err);
    }
  };

  const handleStatusChange = async (id, status) => {
    try {
      await api.updateSubmissionStatus(id, status);
      load();
    } catch (err) {
      alert('Failed to update status: ' + err.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this submission?')) return;
    try {
      await api.deleteSubmission(id);
      load();
    } catch (err) {
      alert('Failed to delete: ' + err.message);
    }
  };

  const filteredSubmissions = filter === 'all' 
    ? submissions 
    : submissions.filter(s => s.status === filter);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">Form Submissions</h2>
        <div className="flex gap-2">
          {['all', 'new', 'read', 'replied'].map(f => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              className={`px-3 py-1 text-sm rounded capitalize ${
                filter === f ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {f}
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-4">
        {filteredSubmissions.map((sub) => (
          <div key={sub.id} className={`p-4 border rounded-lg ${
            sub.status === 'new' ? 'border-blue-300 bg-blue-50' : 'border-gray-200'
          }`}>
            <div className="flex items-start justify-between mb-2">
              <div>
                <p className="font-medium text-gray-900">{sub.name}</p>
                <p className="text-sm text-gray-600">{sub.email}</p>
                {sub.phone && <p className="text-sm text-gray-600">{sub.phone}</p>}
              </div>
              <select
                value={sub.status}
                onChange={(e) => handleStatusChange(sub.id, e.target.value)}
                className="text-sm px-2 py-1 border border-gray-300 rounded"
              >
                <option value="new">New</option>
                <option value="read">Read</option>
                <option value="replied">Replied</option>
              </select>
            </div>
            
            <p className="text-gray-700 mb-2">{sub.message}</p>
            
            <div className="flex items-center justify-between text-xs text-gray-500">
              <span>{new Date(sub.submitted_at).toLocaleString()}</span>
              <button
                onClick={() => handleDelete(sub.id)}
                className="text-red-600 hover:text-red-800"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {filteredSubmissions.length === 0 && (
        <div className="text-center py-12 text-gray-500">
          No submissions found.
        </div>
      )}
    </div>
  );
};

export default SubmissionsPanel;
